export const stateKeys = {
  referenceLoading: 'referenceLoading',
  referenceCodeWorkflowStatus: 'referenceCodeWorkflowStatus',
  candidateReference: 'candidateReference',
};

export const stateLoadingKeys = {
  [stateKeys.referenceLoading]: stateKeys.referenceLoading
};


// WEBPACK FOOTER //
// ./src/constants/references.js